exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../node_modules/css-loader/index.js??ref--6-oneOf-1-1!../../node_modules/vue-loader/lib/loaders/stylePostLoader.js!../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-2!../../node_modules/postcss-loader/src/index.js??ref--6-oneOf-1-3!./columns.css"), "");

// module
exports.push([module.id, ".oo-container.hide[data-v-78d797d3]{display:none}.oo-content-title[data-v-78d797d3]{border-top:1px solid #fff}", ""]);

// exports
